<!--
import Radio from "@/components/common/ui/Radio";
 <Radio
				name="typesq"
				v-model="types"
				label="1"
				text="显示文本"
			></Radio>
			
			disabled =>false 可编辑(已经取消该元素)  实现不可编辑在class中加入disable
			name =》同input
			label =》绑定的value值
			text=》显示文本
-->
<template>
	<label class="radio radio-box curP vaT_E">
		<input type="radio" :name="name" v-model="vValue" :value="label" @change="onChange" />
		<span
			class="radio-inner dpIB tra-fast"
			:class="{ checked: label === vValue, bdPrimary: !disabled, bdOuter: label !== vValue || disabled, bgDisabeled: disabled }"
		></span>
		<span class="dpIB pl05x content">{{ text }}<slot></slot></span>
	</label>
</template>
<script>
export default {
	name: "radio",
	data() {
		return {
			//randomId: 'id' + Math.random().toString(36).substr(2, 3)
			valueInput: "",
		};
	},
	props: {
		value: {
			type: [String, Number, Boolean],
			defalut: undefined,
		},
		label: {
			type: [String, Number, Boolean],
			defalut: null,
		},
		name: {
			type: String,
			default: "type",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		text: {
			type: [String, Number],
			defalut: "",
		},
		checkObj: {
			type: Object,
			defalut: null,
		},
		change: Function,
	},
	methods: {
		onChange() {
			if (this.checkObj) {
				this.$nextTick((_) => {
					this.$emit("change", this.vValue, this.checkObj);
				});
			} else {
				this.$nextTick((_) => {
					this.$emit("change", this.vValue);
				});
			}
		},
	},
	mounted() {
		// this.$nextTick(() => {
		//   this.valueInput = this.label || this.value
		// })
	},
	computed: {
		vValue: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit("input", v);
			},
		},
	},
};
</script>
<style lang="scss" scoped>
.bgDisabeled {
	background: rgba(0, 0, 0, 0.04);
}
.radio-box {
	overflow: hidden;
}
.radio {
	display: inline-block;
	white-space: nowrap;
	// label {
	// display: flex;
	// flex-direction: row;
	// line-height: 1.2em;
	// }
	.content {
		position: relative;
		top: -0.25rem;
		white-space: normal;
		// flex: 1;
	}
	.radio-inner {
		position: relative;
		width: 2rem;
		height: 2rem;
		overflow: hidden;
		// display:block;
		border-radius: 50%;
		&:before {
			position: absolute;
			top: 50%;
			left: 50%;
			display: block;
			width: 1rem;
			height: 1rem;
			content: "";
			border-radius: 50%;
			transition: transform 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
			transform: scale(0);
			margin: {
				top: -0.5rem;
				left: -0.5rem;
			}
		}
		&:hover {
			border-color: $primary;
		}
	}
	.checked:before {
		background-color: $primary;
		transform: scale(1);
	}
	.bgDisabeled:before {
		background-color: $border-light;
		transform: scale(1);
	}
	[type="radio"] {
		display: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/Radio.vue